export default __webpack_public_path__ + "8b258ac9133721ea6d3acd1c6a3cb437.jpg";